/* eslint-disable react-hooks/exhaustive-deps */
import { useState, createContext, useCallback } from 'react'
import { AuthSome } from '../../Config/Permisos';
import { Estado, EstadoNull } from '../../Models/General';
import { Cliente, conCliente, ClienteNull } from '../../Models/Ventas';
import { formatoHora } from '../../Utiles/Formatos';
import { sleep, useSemaforo } from '../../Utiles/ReactUtils';

export interface ClientesType {
    estCliente: Estado
    Clientes: Cliente[]
    actCliente: () => void
    findCliente: (c: string) => Cliente
}
function arrayToClientes(c: any[]): Cliente[] {
    return c.map(a => {
        return {
            codigo: a[0],
            nombre: a[1],
            telefono: a[2],
            correo: a[3],
            contacto: a[4],
            direccion: a[5],
            tipo_contribuyente: a[6],
            retencion: a[7],
            estatus: a[8],
            pais: a[9],
            ciudad: a[10],
            estado: a[11]
        }
    })
}
function setCambioClientes(data: Cliente[], c: Cliente[]) {
    const c2 = arrayToClientes(data);
    const push = c2.filter(((d: Cliente) => {
        const i = c.findIndex(c => c.codigo === d.codigo);
        if (i > -1) {
            c[i] = d;
            return false;
        }
        return true;
    }));
    const Clientes = [...c, ...push];
    return Clientes;
}
export const ClientesContext = createContext<ClientesType | null>(null)
export default function ClientesProvider({ children }: { children: any }) {
    const [Clientes, setClientes] = useState<Cliente[]>([]);
    const [est, setest] = useState(EstadoNull);
    const [con] = useState(conCliente());
    const update = useCallback(async () => {
        if (AuthSome(['FACTURA', 'NOTA', 'COTIZACION', 'CLIENTE'])) con.cambios((data: any[]) => {
            setClientes(setCambioClientes(data, Clientes))
            setest({ status: 3, hora: formatoHora(con.state) });
        })
        await sleep(50);
    }, [Clientes])
    useSemaforo('Clientes', async () => {
        await update()
    })
    const findCliente = useCallback((p: string) => {
        const pro = Clientes.find(Pro => Pro.codigo === p);
        if (pro !== undefined) return pro;
        return ClienteNull;
    }, [Clientes])
    return <ClientesContext.Provider value={{
        estCliente: est,
        Clientes: Clientes,
        actCliente: update,
        findCliente: findCliente
    }}>
        {children}
    </ClientesContext.Provider>
}
export const SeccionConsumer = ClientesContext.Consumer;